import { call, all, select } from 'redux-saga/effects';
import { DICOMViewerSlice } from '@restore/DICOMViewer/DICOMViewer.slice';
import { clinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { clinicalTrialInventorySlice } from '@restore/clinicalTrialInventory/clinicalTrialInventory.slice';
import { QCTaskSlice, selectQCTaskState } from '@restore/QCTask/QCTask.slice';
import { QCTaskUploadsListSlice } from '@restore/QCTaskUploadsList/QCTaskUploadsList.slice';
import { QCTaskPatientSlice } from '@restore/QCTaskPatient/QCTaskPatient.slice';
import { QCTaskSeriesSlice } from '@restore/QCTaskSeries/QCTaskSeries.slice';
import { dispatch, getUrlParams } from '@restore/helpers';
import { fetchQCTaskDefinitions } from 'src/store-redux/QCTaskDefinition/QCTaskDefinition.slice';
import { fetchClinicalTrialContextWorker } from 'src/store-redux/clinicalTrialContext/clinicalTrialContext.saga';
import { fetchImagingSpecialistInstrumentsWorker } from 'src/store-redux/clinicalTrialInventory/clinicalTrialInventory.saga';
import { fetchQCTaskWorker } from 'src/store-redux/QCTask/QCTask.saga';
import { fetchQCTaskUploadsListWorker } from 'src/store-redux/QCTaskUploadsList/QCTaskUploadsList.saga';
import { fetchQCTaskPatientWorker } from 'src/store-redux/QCTaskPatient/QCTaskPatient.saga';
import { fetchQCTaskSeriesWorker } from 'src/store-redux/QCTaskSeries/QCTaskSeries.saga';
import { QCTaskDefinitionsWorker } from 'src/store-redux/QCTaskDefinition/QCTaskDefinition.saga';

const { fetchNeededDataSuccess, fetchNeededDataFailure } =
  DICOMViewerSlice.actions;

const { fetchClinicalTrialContext } = clinicalTrialContextSlice.actions;

const { fetchImagingSpecialistInstruments } =
  clinicalTrialInventorySlice.actions;

const { fetchQCTask } = QCTaskSlice.actions;

const { fetchQCTaskUploadsList } = QCTaskUploadsListSlice.actions;

const { fetchQCTaskPatient } = QCTaskPatientSlice.actions;

const { fetchQCTaskSeries } = QCTaskSeriesSlice.actions;

export function* fetchQCNeededDataWorker() {
  const { id: clinicalTrialId, taskId } = yield call(getUrlParams);
  if (!(clinicalTrialId && taskId)) {
    return;
  }
  try {
    yield all([
      call(
        fetchClinicalTrialContextWorker,
        fetchClinicalTrialContext(clinicalTrialId)
      ),
      call(
        fetchImagingSpecialistInstrumentsWorker,
        fetchImagingSpecialistInstruments(clinicalTrialId)
      ),
      call(fetchQCTaskWorker, fetchQCTask({ clinicalTrialId, taskId })),
      call(
        fetchQCTaskUploadsListWorker,
        fetchQCTaskUploadsList({ clinicalTrialId, taskId })
      ),
      call(
        fetchQCTaskPatientWorker,
        fetchQCTaskPatient({ clinicalTrialId, taskId })
      ),
      call(
        fetchQCTaskSeriesWorker,
        fetchQCTaskSeries({ clinicalTrialId, taskId })
      ),
    ]);

    const { data: taskData }: ReturnType<typeof selectQCTaskState> =
      yield select(selectQCTaskState);
    if (taskData?.patientId) {
      const { visitId, patientId } = taskData;

      yield call(
        QCTaskDefinitionsWorker,
        fetchQCTaskDefinitions({ clinicalTrialId, visitId, patientId })
      );
    }

    yield dispatch(fetchNeededDataSuccess(undefined));
  } catch (e) {
    yield dispatch(fetchNeededDataFailure(e as Error));
    console.error('fetchQCNeededDataWorker', e);
  }
}
